var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"type":"number","required":_vm.required,"disabled":_vm.disabled,"readonly":_vm.readonly},domProps:{"value":_vm.value},on:{"change":function($event){return _vm.$emit('input', $event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }